import { render } from "./InputClear.vue?vue&type=template&id=a511f426"
import script from "./InputClear.vue?vue&type=script&lang=js"
export * from "./InputClear.vue?vue&type=script&lang=js"

import "./InputClear.vue?vue&type=style&index=0&id=a511f426&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__